import { CommonLaboratoryResponse } from '@/api/services/common.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { Nullable } from '@/shared/types/app.types'

export interface DiagnosisConsultationModalConsultationNewState {
    laboratory: Nullable<CommonLaboratoryResponse>
    pathologists: CommonPersonnelResponse[]
    pathologist: Nullable<CommonPersonnelResponse>
    observations: Nullable<string>
}
export const initialDiagnosisConsultationModalConsultationNewState =
    (): DiagnosisConsultationModalConsultationNewState => ({
        laboratory: null,
        pathologists: [],
        pathologist: null,
        observations: null
    })
